var _a, _b;
import axios from "axios";
import { AxiosClientFactory } from './AxiosClientFactory';
import { environmentUrls } from './environmentUrls';
import { getRandomInt } from "@nbly/common";
export var defaultTransformRequests = new Array()
    .concat((_a = axios.defaults.transformRequest) !== null && _a !== void 0 ? _a : [], function (data, headers) {
    headers['X-Corellation-Id'] = getRandomInt(1, Number.MAX_SAFE_INTEGER);
    return data;
});
export var defaultTransformResponses = new Array()
    .concat((_b = axios.defaults.transformResponse) !== null && _b !== void 0 ? _b : [], function (data, headers) {
    return data;
});
export var defaultHeaders = {
    common: {
        Accept: "application/json, text/plain, */*",
        'x-requested-with': "xmlhttprequest"
    }
};
export var environment = {
    coreApiClientFactory: new AxiosClientFactory("core", {
        baseURL: environmentUrls.coreBaseUrl,
        transformRequest: defaultTransformRequests,
        transformResponse: defaultTransformResponses,
        headers: defaultHeaders,
    }),
    identityClientFactory: new AxiosClientFactory("identity", {
        baseURL: environmentUrls.identityBaseUrl,
        transformRequest: defaultTransformRequests,
        transformResponse: defaultTransformResponses,
        headers: defaultHeaders,
    }),
    unifiedSyncPlatformClientFactory: new AxiosClientFactory("unifiedSyncPlatform", {
        baseURL: environmentUrls.unifiedSyncPlatformBaseUrl,
        transformRequest: defaultTransformRequests,
        transformResponse: defaultTransformResponses,
        headers: defaultHeaders,
    }),
    serviceOrchestrationsClientFactory: new AxiosClientFactory("serviceOrchestrations", {
        baseURL: environmentUrls.serviceOrchestrationsApiBaseUrl,
        transformRequest: defaultTransformRequests,
        transformResponse: defaultTransformResponses,
        headers: defaultHeaders,
    }),
    franchiseGroupClientFactory: new AxiosClientFactory("franchiseGroup", {
        baseURL: environmentUrls.franchiseGroupBaseUrl,
        transformRequest: defaultTransformRequests,
        transformResponse: defaultTransformResponses,
        headers: defaultHeaders,
    }),
    callCenterOrchestrationsClientFactory: new AxiosClientFactory("callCenterOrchestrations", {
        baseURL: environmentUrls.callCenterOrchestrationsBaseUrl,
        transformRequest: defaultTransformRequests,
        transformResponse: defaultTransformResponses,
        headers: defaultHeaders,
    }),
    syncGroupClientFactory: new AxiosClientFactory("syncGroup", {
        baseURL: environmentUrls.syncGroupUrl,
        transformRequest: defaultTransformRequests,
        transformResponse: defaultTransformResponses,
        headers: defaultHeaders,
    }),
};
